import React from 'react';
import styles from './ourstory.module.css';
import basestyles from '../../styles/basestyles.module.css';

function Ourstory() {
    return (
      
     <div id="ourstory" className={styles.background}>
        <div className={basestyles.maxWidth}>
        <h1 className={styles.story}>Our Story</h1>
       <div className={styles.useflex}>
         <img src="our-story.jpeg" alt="our-story"/>
         <p className={styles.first}>
           As we belong to the farmer's family,our mission is to help farmers across India to get potential income every day and fill the customer's stomach with chemical-free food. To implement this, we currently joined our hands with the Village youth association in Karnataka. It's a platform to help village farmers across karnataka, who grow pesticide-free fruits and vegetables.
         </p>
       </div>
       <div>
  <p className={styles.second}>
    This is how our team got an opportunity to connect well with trusted farmers across Karnataka. Stated directly to source 100% fresh fruits,   vegetables and grains year-round from them and deliver it to retailers and consumers within 12 hours.
  </p>
       </div>
        </div>
      
     </div>
    );
  }
  
  export default Ourstory;
  